export class EventEmitter {
    constructor() {
        this.events = {};
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    }
    trigger(eventName, ...args) {
        if (this.events[eventName]) {
            this.events[eventName].forEach((callback) => {
                return callback(...args);
            });
        }
    }
}
//# sourceMappingURL=EventEmitter.js.map